/* ==== MM / Comparateur matelas — JS ======================================
   Les produits comparables sont décrits dans [data-compare-products] (JSON,
   un objet product PAR ID — payload.products = { "<product.id>": {...} }),
   couvrant TOUTE la collection choisie en admin, pas seulement les 3 cartes
   affichées : n'importe lequel peut être choisi via le dropdown d'une carte
   non sélectionnée. Au changement, la carte se met à jour — crossfade image,
   points en cascade, prix qui pope. Mobile : slider snap + drag + barre de
   progression.                                                          */
(function () {
  'use strict';

  function renderDots(container, n) {
    var html = '';
    for (var i = 0; i < 5; i++) {
      html += '<span' + (i < n ? ' class="is-on" style="--i:' + i + '"' : '') + '></span>';
    }
    container.innerHTML = html;
    var label = container.getAttribute('aria-label');
    if (label) container.setAttribute('aria-label', label.replace(/\d+\/5$/, n + '/5'));
  }

  function initCompare(root) {
    var payload = JSON.parse(root.querySelector('[data-compare-products]').textContent);
    var data = payload.products || {};

    function fill(card, product, animate) {
      var img = card.querySelector('.mm-mcard__media img, .mm-mcard__image');
      if (img && product.image) {
        img.classList.remove('is-entering');
        if (animate) {
          img.src = product.image;
          void img.offsetWidth;
          img.classList.add('is-entering');
        } else {
          img.src = product.image;
        }
      }

      var name = card.querySelector('[data-dd-value]');
      if (name) name.textContent = product.name;

      var badge = product.badge || '';
      card.querySelectorAll('[data-dd-badge-label], [data-model-badge]').forEach(function (el) {
        var text = el.querySelector('.mm-label-text') || el;
        text.textContent = badge;
        el.classList.toggle('is-empty', !badge);
      });

      /* note : repointée sur le nouveau produit, lue sur l'API Avis Vérifiés */
      var rating = card.querySelector('[data-skp-rating]');
      if (rating && window.SkeepersRatingManager) window.SkeepersRatingManager.update(rating, product.id);

      card.querySelectorAll('[data-spec]').forEach(function (el) {
        var key = el.getAttribute('data-spec');
        var value = product[key];
        if (el.classList.contains('mm-mcard__dots')) {
          renderDots(el, parseInt(value, 10) || 0);
        } else {
          el.textContent = value || '';
        }
      });

      var price = card.querySelector('[data-price]');
      var compare = card.querySelector('[data-compare-price]');
      if (price) {
        price.textContent = product.price;
        if (animate && window.MmMotion) MmMotion.pop(price);
      }
      if (compare) compare.textContent = product.compare || '';

      var cta = card.querySelector('.mm-mcard__cta');
      if (cta && product.url) cta.setAttribute('href', product.url);
    }

    /* ---- exclusion croisée : un matelas déjà affiché par une carte
       (y compris la carte « sélectionnée », sans dropdown) ne doit plus
       être proposable dans les sélecteurs des autres cartes. Comparaison
       par ID produit (string), plus par index de bloc. ---- */
    var cards = Array.prototype.slice.call(root.querySelectorAll('.mm-mcard'));
    function refreshTaken() {
      var pris = cards.map(function (c) { return c.dataset.mmCurrent; });
      cards.forEach(function (card, ci) {
        card.querySelectorAll('.mm-dd__option').forEach(function (opt) {
          var v = opt.getAttribute('data-value');
          var taken = v !== pris[ci] && pris.indexOf(v) !== -1;
          if (taken) opt.setAttribute('aria-disabled', 'true');
          else opt.removeAttribute('aria-disabled');
          opt.classList.toggle('is-taken', taken);
        });
      });
    }

    cards.forEach(function (card) {
      var id = card.getAttribute('data-product-id');
      card.dataset.mmCurrent = id;

      var dd = card.querySelector('.mm-dd');
      if (dd) {
        dd.addEventListener('mm:change', function (e) {
          var newId = e.detail.value;
          if (!data[newId]) return;
          card.dataset.mmCurrent = newId;
          fill(card, data[newId], true);
          refreshTaken();
        });
      }
    });
    refreshTaken();

    var sizeBadge = root.querySelector('[data-size-badge]');
    if (sizeBadge) {
      var sizes = JSON.parse(sizeBadge.getAttribute('data-size-variants') || '{}');
      var sizeText = sizeBadge.querySelector('.mm-label-text') || sizeBadge;
      document.addEventListener('product:variant-found', function (e) {
        var label = sizes[e.detail && e.detail.data && e.detail.data.variantId];
        if (label) sizeText.textContent = label;
      });
    }
  }

  document.querySelectorAll('.mm-comparateur-matelas').forEach(initCompare);
})();
